// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__eYK0s","label":"Labeled_label__3mW3E","divider":"Labeled_divider__1iZ_u"};